class ExceptionStateFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "new": {
        "title": "New",
        "selected": false
      },
      "in_progress":{
        "title": "In Progress",
        "selected": false
      },
      "waiting_refund": {
        "title": "Waiting Refund",
        "selected": false
      },
      "waiting_external": {
        "title": "Waiting External",
        "selected": false
      },
      "waiting_dev": {
        "title": "Waiting Development",
        "selected": false
      },
      "resolved": {
        "title": "Resolved",
        "selected": false
      },
      "resolved_externally": {
        "title": "Resolved Externally",
        "selected": false
      },
      "resolved_by_system": {
        "title": "Resolved By System",
        "selected": false
      },
      "invalid": {
        "title": "Invalid",
        "selected": false
      },
      "wont_fix": {
        "title": "Wont Fix",
        "selected": false
      },
      "to_query": {
        "title": "To Query with Partner",
        "selected": false
      }
    }
  }
}

ExceptionStateFilter.defaultProps = {
  "emptySelectedString": "All States",
  "defaults": ["new"],
  "filterKey": "exceptionState",
  "filterIcon": "icon-streamline-sync"
}

class ExceptionCategoryFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "settlement": {
        "title": "Settlement",
      },
      "transaction": {
        "title": "Transaction",
      },
      "payworks": {
        "title": "Payworks",
      },
      "firebase": {
        "title": "Firebase",
      },
      "qamatha": {
        "title": "Qamatha",
      },
      "prime": {
        "title": "Prime",
      },
      "onboarding": {
        "title": "Onboarding",
      },
    }
  }
}

ExceptionCategoryFilter.defaultProps = {
  "emptySelectedString": "All Categories",
  "filterKey": "category",
  "filterIcon": "icon-magnifier"
}

class PaymentProcessorFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "ono": {
        "title" : "Ono"
      },
      "thrive": {
        "title": "Thrive"
      }
    }
  }
}

PaymentProcessorFilter.defaultProps = {
  "emptySelectedString": "All Payment Processors",
  "filterKey": "paymentProcessor",
  "filterIcon": "icon-magnifier"
}

class PaymentProcessingBankFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "absa": {
        "title" : "ABSA"
      },
      "direct_transact": {
        "title" : "Direct Transact"
      }
    }
  }
}

PaymentProcessingBankFilter.defaultProps = {
  "emptySelectedString": "All Processing Banks",
  "filterKey": "processingBank",
  "filterIcon": "icon-magnifier"
}

class PaymentExceptionCategoryFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "settlement": {
        "title": "Settlement",
      },
      "transaction": {
        "title": "Transaction",
      }
    }
  }
}

PaymentExceptionCategoryFilter.defaultProps = {
  "emptySelectedString": "All Categories",
  "filterKey": "category",
  "filterIcon": "icon-magnifier"
}

class SystemExceptionCategoryFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "payworks": {
        "title": "Payworks",
      },
      "firebase": {
        "title": "Firebase",
      },
      "qamatha": {
        "title": "Qamatha",
      },
      "fee_migration": {
        "title": "Fee Migration"
      },
      "fee_revision": {
        "title": "Fee Revision"
      }
    }
  }
}

SystemExceptionCategoryFilter.defaultProps = {
  "emptySelectedString": "All Categories",
  "filterKey": "category",
  "filterIcon": "icon-magnifier"
}

class OnboardingExceptionCategoryFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      "prime": {
        "title": "Prime",
      },
      "onboarding": {
        "title": "Onboarding",
      },
    }
  }
}

OnboardingExceptionCategoryFilter.defaultProps = {
  "emptySelectedString": "All Categories",
  "filterKey": "category",
  "filterIcon": "icon-magnifier"
}

class PaymentExceptionTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      'transaction_conflicting_states': {
        title: 'Transaction Conflicting States'
      },
      'failed_transaction_settled': {
        title: 'Failed Transaction Settled'
      },
      'inconsistent_settlement_data': {
        title: 'Inconsistent Settlement Data'
      },
      'unknown_transaction_settled': {
        title: 'Unknown Transaction Settled'
      },
      'transaction_not_settled': {
        title: 'Transaction Not Settled'
      },
      'unexpected_reversal_settled': {
        title: 'Unexpected Reversal Settled'
      },
      'unexpected_transaction_settled': {
        title: 'Unexpected Transaction Settled'
      },
      'unknown_transaction': {
        title: 'Unknown Transaction'
      },
      'unknown_reversal_settled': {
        title: 'Unknown Reversal Settled'
      },
      'transaction_abnormal': {
        title: 'Transaction Abnormal'
      }
    }
  }
}

PaymentExceptionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "exceptionType",
  "filterIcon": "icon-magnifier"
}

class SystemExceptionTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      'qamatha_unknown_response': {
        title: 'Qamatha Unknown Response'
      },
      'firebase_sync_failed': {
        title: 'Firebase Sync Failed'
      },
      'unknown_transaction': {
        title: 'Unknown Transaction'
      },
      'payworks_error': {
        title: 'PayworksError'
      },
      'fee_rate_generation_failure': {
        title: 'Fee Generation'
      },
      'fee_field_validation_failure': {
        title: 'Fee Validation'
      }
    }
  }
}

SystemExceptionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "exceptionType",
  "filterIcon": "icon-magnifier"
}

class OnboardingExceptionTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      'mercantile_prime_request_failed': {
        title: 'Prime Request Failed'
      },
      'mercantile_prime_invalid_state': {
        title: 'Prime Invalid State'
      },
      'vetting_blocked_by_match': {
        title: 'Verification Blocked by Match'
      },
      'stripe_passed_on_failed_sign_up': {
        title: 'Stripe Payment Passed on Failed Signup'
      },
      'payment_passed_on_failed_sign_up': {
        title: 'Payment Passed on Failed Signup'
      },
      'match_error': {
        title: 'Match Error'
      }

    }
  }
}

OnboardingExceptionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "exceptionType",
  "filterIcon": "icon-magnifier"
}

class PayoutExceptionTypeFilter extends waffle.filters.BaseFilter {
  loadAvailableOptions() {
    return {
      'instant_payout': {
        title: 'Instant Payout'
      },
      'payout_processing_error': {
        title: 'Payouts Processing Error'
      },
      'payout_submission_failed': {
        title: 'Payouts Submission Failed'
      },
      'payout_not_matched': {
        title: 'Payout Not Matched'
      },
      'payouts_not_accepted': {
        title: 'Payouts not Accepted'
      },
      'outbound_payouts_failed': {
        title: 'Payouts Failed'
      },
      'outbound_payouts_upload_failed': {
        title: 'Payouts Upload Failed'
      },
      'absa_rtc_za_service': {
        title: 'Absa RTC ZA Service'
      }
    }
  }
}

PayoutExceptionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "exceptionType",
  "filterIcon": "icon-magnifier"
}

export class PaymentExceptionFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <ExceptionStateFilter />
      <PaymentExceptionCategoryFilter />

      <PaymentExceptionTypeFilter />
      <PaymentProcessingBankFilter />
      <PaymentProcessorFilter />
    </waffle.blocks.FilterBlock>
  }
}

export class OnboardingExceptionFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <ExceptionStateFilter />
      <SystemExceptionCategoryFilter />
      <OnboardingExceptionTypeFilter />
    </waffle.blocks.FilterBlock>
  }
}

export class SystemExceptionFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <ExceptionStateFilter />
      <SystemExceptionCategoryFilter />
      <SystemExceptionTypeFilter />
    </waffle.blocks.FilterBlock>
  }
}

export class PayoutExceptionFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <ExceptionStateFilter />
      <PayoutExceptionTypeFilter />
    </waffle.blocks.FilterBlock>
  }
}

export class ExceptionFilterBlock extends waffle.base.BaseComponent {
  render() {
    return <waffle.blocks.FilterBlock>
      <ExceptionStateFilter />
      <ExceptionCategoryFilter />
    </waffle.blocks.FilterBlock>
  }
}
